import { AuditTypes } from '../../../../../../shared/constants/audit-types';
import { AccessibilityAuditToolNames } from '../../../../../../shared/constants/audit-tool';

export enum InUseAuditTypes {
  accessibility = AuditTypes.accessibility,
  accessibility_ibm = AuditTypes.accessibility_ibm,
  accessibility_axe = AuditTypes.accessibility_axe,
  accessibility_wave = AuditTypes.accessibility_wave,
  accessibility_access = AuditTypes.accessibility_access,
  accessibility_rulebase = AuditTypes.accessibility_rulebase,
}

export const AuditTypeToAuditToolName: Readonly<Record<InUseAuditTypes, AccessibilityAuditToolNames>> = Object.freeze({
  [AuditTypes.accessibility]: AccessibilityAuditToolNames.aslint,
  [AuditTypes.accessibility_ibm]: AccessibilityAuditToolNames.ibm,
  [AuditTypes.accessibility_axe]: AccessibilityAuditToolNames.axe,
  [AuditTypes.accessibility_wave]: AccessibilityAuditToolNames.wave,
  [AuditTypes.accessibility_access]: AccessibilityAuditToolNames.access_engine,
  [AuditTypes.accessibility_rulebase]: AccessibilityAuditToolNames.rulebase,
});
